import { defineComponent as m, computed as u, openBlock as c, createBlock as d, resolveDynamicComponent as w, normalizeClass as S, unref as $, withCtx as x, renderSlot as C } from "vue";
import s from "../../node_modules/.pnpm/@patternfly_react-styles@5.3.1/node_modules/@patternfly/react-styles/css/layouts/Grid/grid.js";
import { breakpoints as O } from "../../breakpoints.js";
const g = /* @__PURE__ */ m({
  name: "PfGridItem",
  __name: "GridItem",
  props: {
    component: { default: "div" },
    span: {},
    rowSpan: {},
    offset: {},
    sm: {},
    smRowSpan: {},
    smOffset: {},
    md: {},
    mdRowSpan: {},
    mdOffset: {},
    lg: {},
    lgRowSpan: {},
    lgOffset: {},
    xl: {},
    xlRowSpan: {},
    xlOffset: {},
    xl2: {},
    xl2RowSpan: {},
    xl2Offset: {}
  },
  setup(l) {
    const e = l, i = u(() => {
      const o = [];
      e.span && o.push(s.modifiers[`${e.span}Col`]), e.rowSpan && o.push(s.modifiers[`${e.rowSpan}Row`]), e.offset && o.push(s.modifiers[`offset_${e.offset}Col`]);
      for (const f of O) {
        let t;
        if (f === "")
          continue;
        let n;
        f === "2xl" ? (t = "xl2", n = "_2xl") : (t = f.toLowerCase(), n = f);
        const r = e[t], p = e[`${t}RowSpan`], a = e[`${t}Offset`];
        r && o.push(s.modifiers[`${r}ColOn${n}`]), p && o.push(s.modifiers[`${p}RowOn${n}`]), a && o.push(s.modifiers[`offset_${a}ColOn${n}`]);
      }
      return o;
    });
    return (o, f) => (c(), d(w(o.component), {
      class: S([$(s).gridItem, ...i.value])
    }, {
      default: x(() => [
        C(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  g as default
};
